import { Component } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-checkbox',
    template: `<div>
    <ngl-checkbox [label]="to.label || ''" [ngClass]="to['customClass']" (change)="change(field)">
      <input
        ngl
        type="checkbox"
        [formControl]="$any(formControl)"
        [required]="to.required || false"
        [placeholder]="to.placeholder"
      />
    </ngl-checkbox>
  </div>`,
    styleUrls: ['./checkbox.type.component.scss'],
    standalone: false
})
export class CheckboxTypeComponent extends FieldType {
  public change(field?: FormlyFieldConfig): void {
    if (field?.templateOptions && field.templateOptions['onChange']) {
      const value = this.model[this.key.toString()];
      field.templateOptions['onChange'](this, value, this.model);
    }
  }
}
